import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Container,
  FormFile
} from "react-bootstrap";
import "./CategoryViewModal.css";
import { Link } from "react-router-dom";
import { Card } from "reactstrap";
import Form from "react-bootstrap/Form";
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Switch from "react-switch";

class CategoryViewModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

      userActiveShow: false,
      userSuspndShow: false,
      value: {
        name: '',
        desc: '',
        code: '',
        iconurl: null,
        parent: true,
        isActive: true,

      }

    };
    this.submit = this.submit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.handleChange = this.handleChange.bind(this);
    this.toogileChange = this.toogileChange.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }





  submit() {
    console.log("submit work")
    const value = this.state.value
    console.log("data************", value.name, value.desc, value.code, value.iconurl,
      value.isActive, value.parent)
    if (value.name !== "", value.desc !== "", value.code !== "", value.iconurl !== null) {
      this.props.AddCatgrs(value)
      this.setState({
        value: {
          ...this.state.value,
          name: '',
          desc: '',
          code: '',
          iconurl: null,
          parent: true,
          isActive: true,
        }
      })
    } else {
      toast.error('Please enter valid datas', {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      })
    }


  }
  onChange(value) {
    let field = value.target.name
    let data = value.target.value
    if (field == "name") {
      this.setState({
        value: { ...this.state.value, name: data }
      })
    } else if (field == "Desc") {
      this.setState({
        value: { ...this.state.value, desc: data }
      })
    } else if (field == "code") {
      this.setState({
        value: { ...this.state.value, code: data }
      })
    }

  }
  fileChangedHandler = (event) => {
    const icon = event.target.files[0]

    this.setState({
      value: { ...this.state.value, iconurl: icon }
    })
  }
  handleChange(checked) {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  }
  toogileChange(checked) {
    this.setState({ value: { ...this.state.value, parent: checked } });
  }
  closeModal() {
    this.props.handleClose();
  }
  render() {
    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.closeModal}
            animation={false}
            size="lg"
            backdrop="static"

          >
            <Modal.Header style={{ fontSize: "35px" }} closeButton>
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Category</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body >
              <Container>
                <Form>
                  <Row>
                    <Col lg={6}>
                      <Form.Group controlId="name">
                        <Form.Label> Name</Form.Label>
                        <Form.Control type="text" placeholder="Name" autocomplete="off" name="name" onChange={this.onChange} value={this.state.value.name || ''} />

                      </Form.Group>
                    </Col>
                    <Col lg={6}>

                      <Form.Group controlId="Description">
                        <Form.Label>Description</Form.Label>
                        <Form.Control as="textarea" name="Desc" autocomplete="off" onChange={this.onChange} value={this.state.value.desc} />
                      </Form.Group>

                    </Col>
                  </Row>


                  <Row>
                    <Col lg={6}>
                      <Form.Group controlId="code">
                        <Form.Label> Code</Form.Label>
                        <Form.Control type="text" placeholder="Code" autocomplete="off" name="code" onChange={this.onChange} value={this.state.value.code} />

                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label> IconUrl</Form.Label>
                        <Form.File id="exampleFormControlFile1" name="icon" onChange={this.fileChangedHandler} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <label>

                        <span>Active</span>
                        <Switch onChange={this.handleChange} onColor="#20a8d8" checked={this.state.value.isActive} />
                      </label>
                    </Col>
                    <Col lg={6}>
                      <label>
                        <span>Parent</span>
                        <Switch onChange={this.toogileChange} onColor="#20a8d8" checked={this.state.value.parent} />
                      </label>


                    </Col>
                  </Row>

                </Form>

              </Container>
            </Modal.Body>

            <Modal.Footer>
              <Button
                className="CategorybtnSubmit"
                onClick={this.submit}
              >
                Submit
                  </Button>
            </Modal.Footer>

          </Modal>
        </div>
      </div>
    );
  }
}
export default CategoryViewModal;

